import { render, staticRenderFns } from "./ProductEditSpecification.vue?vue&type=template&id=704764ab&"
import script from "./ProductEditSpecification.vue?vue&type=script&lang=js&"
export * from "./ProductEditSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports